(function(){

  angular.module('irricrops')

  .controller("vinedoResumenCtrl", [ 'resumen', 'cuartelDialog','CuartelRes','Config', 'MultiChart','$mdToast',
    'VinedoRes','vinedo','$q','global','$timeout',"$compile","$scope","$mdDialog", "EquipoRes","SensorFac",'VinedoFac','$http','urls',
    function(resumen, cuartelDialog,CuartelRes, Config, MultiChart, $mdToast,
      VinedoRes, vinedo,$q, global, $timeout, $compile, $scope, $mdDialog, EquipoRes, SensorFac, VinedoFac, $http, urls) {

      var vm                     = this;
      var equipos                = resumen.data.vinedo.equipos;
      var casetas                = resumen.data.vinedo.casetas;
      var mt                     = moment(); // moment();
      var dias                   = 7;
      var mi                     = moment(mt).subtract(dias-1, "days");
      var mcSensores             =  [];
      var mchart                 = null;
      var UR                     = 30; //testing
      var CC                     = 85; // testing
      var dataRiego              = null;
      var tolerancia_validez_dia = 30; //tolerancia de % de validez de un dia


      vm.visibleSensores    = false;
      vm.visibleSeriesDebug = false;
      vm.showedTemp         = true;
      vm.equipos            = equipos;
      vm.casetas            = casetas;
      vm.casetaSelected     = null;
      vm.equipoSelected     = null;
      vm.sectoresSensor     = [];
      vm.visible            = false;
      vm.etConfig           = null;
      vm.isMobile           = false;
      vm.tabClima           = true;
      vm.hideClima          = true;
      vm.dataClima          = [];
      vm.et_principal       = null;
      vm.gradosDia          = [];
      vm.config             = Config;

      vm.miDate  = mi.toDate();
      vm.mtDate  = mt.toDate();
      vm.loading = {
        getSensores : true
      }

      /*
       * variables usada para el panel debug (v1)
       **/
      vm.debug = {
        enabledPanel: false,
        hidePanel : true,
        loading:{
          getTemporada: false,
          getSensores: false,
        },
        changeDates: function(){
          var oneDay = 24*60*60*1000;
          dias       = _.round(Math.abs((vm.miDate.getTime() - vm.mtDate.getTime())/(oneDay)));
          mi         = moment(vm.miDate);
          mt         = moment(vm.mtDate);
          init();
        }
      };


      /**
       * Funcion para cuando la pagina se redimenciona
       * pensada para el responsive de la plataforma
       */
      var resizeFn = function() {
        vm.isMobile = false;
        if(global.responsiveIs("xs sm")){
          vm.isMobile = true;
        }
      };
      $(window).resize(resizeFn);
      resizeFn();




      /**
       * reglas para temperatura
       */
      var rulers = [
        {
          name         : "0º",
          warningColor : "#f44336", //menores a 0
          lineColor    : "#f44336",  //red
          num          : 0,
        },
        {
          name         : "7º",
          warningColor : "#fdd835", //menores a 7
          lineColor    : "#fdd835", // yellow
          num          : 7,
        },
        {
          name         : "25º",
          warningColor : "#9ccc65", //menores a 25
          lineColor    : "#9ccc65", //green
          num          : 25,
        },
        {
          name         : "30º",
          warningColor : "#fdd835", //menores a 30
          lineColor    : "#fdd835", // yellow
          num          : 30,
        }
      ]




      /**
       * funcion para traer una variable usando un path del object
       * usado para config de table  (vm.items)
       */
      vm.get = function(v, path, type){
        if(path === undefined){
          return  "";
        }
        var r = _.get(v,path, '-');

        if(type === "date_string" &&
          moment(r).isValid() ){
          r = moment(r).format("D, MMM");
        }

        if( _.isNumber(r) &&
          r > 1500000000 && // unix
          moment.unix(r).isValid() &&
          moment.unix(r).isBefore(moment().year(2100))&& //esto para validar el unix
          moment.unix(r).isAfter(moment().year(1900))
        ){
          r = moment.unix(r).format("D, MMM");
        }
        if(_.isNumber(r)){
          r = _.round(r, 1);
        }
        if(r === null){
          r = '-';
        }

        return r;
      }

      vm.refreshDataClima = function(varName, unix, value){
        var found = false;
        _.each(vm.dataClima, function(d){
          if(moment.unix(d.unix).isSame(moment.unix(unix), "day") && d[varName] !== undefined){
            d[varName] = value;
            found = true;
          }
        });
        return found;
      }




      /**
       * umbrales para sensores
       */
      var umbralesSemaforo       = [
        {
          className : "red",
          min: 0
        },
        {
          className : "yellow",
          min: 25
        },
        {
          className : "green",
          min: 50
        }
      ];

      /**
       * obtiene classname segun num
       * para determinar color de semaforo
       * usando  umbralesSemaforo
       */
      vm.getSemaforoByNum = function(num){
        var className = "";
        _.each(umbralesSemaforo, function(u){
          if(num > u.min){
            className = u.className;
          }
        });
        if(num < umbralesSemaforo[0].min){
          className = umbralesSemaforo[0].className
        }
        return className;
      }





      var initTemporadas = function(){
        //get temporada
        //vm.debug.loading.getTemporada = true;
        var temporadaProm = CuartelRes.getTemporada({
          sector_riego_id : equipos[0].sector_riego[0].id,
          fecha_inicio    : mi.format("YYYY-MM-DD"),
          fecha_fin       : mt.format("YYYY-MM-DD")
        }).$promise;



        //funcion al acabar getTemporada
        // determina datos para tabla climatica
        temporadaProm.then(function(data){
          vm.dataClima                  = [];
          dataRiego                     = data.data.riego;
          //vm.debug.loading.getTemporada = false;
          angular.forEach(data.data.riego, function (riego) {
            var d = {
              eto      : _.round(riego.et0, 1),
              etb      : _.round(riego.etb, 1),
              precip   : _.round(riego.precipitacion, 1),
              temp_min : _.round(riego.temperatura_min, 1),
              temp_med : _.round(riego.temperatura_med, 1),
              temp_max : _.round(riego.temperatura, 1),
              unix     : riego.unix,
              date     : moment(riego.unix*1000).format("DD MMM")
            }
            if(Config.vinedo["conBandeja"]){
              //d.et = _.round(riego.etb, 1);
              vm.et_principal = "etb";
            }
            if(Config.vinedo["estacionMet"]){
              //d.et = _.round(riego.et0, 1);
              vm.et_principal = "eto";
            }
            vm.dataClima.push(d);

          });
        });
      }




      var initGD = function(){
        //get grados dia
        //vm.debug.loading.getGd = true;
        var gdProm = VinedoRes.getGradosDia({
          vinedo_id : vinedo.data.id,
        }).$promise;

        gdProm.then(function(res){
          vm.gradosDia = res.data;
        });
      }




      var initSensores = function(){
        vm.loading.getSensores = true;
        var sensoresProm = VinedoRes.getSensores({
          vinedo_id : vinedo.data.id,
          // dias      : dias,
          // fecha     : mi.format("YYYY-MM-DD")
          fecha_inicio    : mi.format("YYYY-MM-DD"),
          fecha_fin       : mt.format("YYYY-MM-DD")
        }).$promise;



        sensoresProm.then(function(res){
          var dataSensores  = res.data;
          var sectores      = dataSensores.sectores;
          mcSensores        = []; //  global
          vm.sectoresSensor = [];

          _.each(sectores, function(sector){
            var dataSumSensores = [];
            var dataSensor      = {};
            var correlacion     = {};

            sector.sectores_riego_or = [];
            _.each(sector.sectores_riego, function(ss){
              var s = vm.getSectorById(ss.id);
              sector.sectores_riego_or.push(s.sector);
            });

            var mc = new MultiChart(sector.nombre);
            mc.toResumen();


            var l = sector.datos[0].length - 1;
            _.each(sector.datos, function(sensor, index){
              if(index == 0){
                _.each(sensor, function(h, i){
                  if(i >0){
                    dataSensor[h] = [];
                    correlacion[i] = h;
                  }
                });
              }else{
                var unix = sensor[0];
                var sum = 0;
                _.each(sensor, function(d, i){
                  if(i >0){
                    dataSensor[correlacion[i]].push([unix*1000, _.round(d, 1)]);
                    sum += _.round(d, 1);
                  }
                });
                if(!sector.sumar){
                  sum = sum / l;
                }
                dataSumSensores.push([unix*1000, _.round(sum, 2)]);

              }
            });


            function sortFunction(a, b) {
              if (a[0] === b[0]) {
                return 0;
              }
              else {
                return (a[0] < b[0]) ? -1 : 1;
              }
            }
            dataSumSensores.sort(sortFunction);
            // _.each(dataSumSensores, function(d){
            //   d[1] = _.round(d[1], 1);
            // });


            var validObj = SensorFac.getValidDays({
              data: dataSumSensores,
              //tolerancia: 0.5, // maximo de pendiente para determinar como valido, TODO TEST
              tolerancia :tolerancia_validez_dia, //tolerancia de % de validez de un dia
              // cc: CC,
              // ur: UR
            });
            var valid = validObj.days;
            //var consumos = SensorFac.getConsumos(dataSumSensores);
            var consumosValidos = SensorFac.getConsumos(dataSumSensores, valid);


            mc.agregarSerie({
              id           : "dev_consumos_validos",
              name         : "consumos",
              type         : 'area',
              step         : "left",
              tag          : "sumasensor",
              data         : consumosValidos.data,
              yAxis        : 12,
              color        : "#bbdefb",
              visibleAxis  : false,
              oppositeAxis : false,
              dataLabels   : {
                enabled : true,
                align   : "left",
                x       : 5
              }
            });

            var l   = sector.datos[0].length - 1;
            var cc  = sector.cc;
            var pmp = sector.pmp;
            var  ur = sector.ur;
            if(sector.sumar){
              cc  = cc * l;
              pmp = pmp * l;
              ur  = ur * l;
            }
            cc  = _.round(cc, 1);
            pmp = _.round(pmp, 1);
            ur  = _.round(ur, 1);


            mc.addPlotLineY({
              value    : cc,
              yAxis    : 4,
              editable : true,
              color    : "#3949ab",
              dashStyle : "Dash",
              dashStyle : "Dash",
              label    : {
                  text          : "CC",
                  textAlign     : "right",
                  useHTML       : true,
                  verticalAlign : "middle",
                  align         : "right",
                  x: -20,
                  style         : {
                    color: Config.colors.cc.background,
                  }
              },
              events: {
                onStop: function(val){
                  console.log("CC change to " + val);
                  var l = sector.datos[0].length - 1;
                  if(sector.sumar){
                    sector.cc = val / l;
                  }else{
                    sector.cc = val;
                  }
                  $http.put(urls.BASE+"/sensor/"+sector.id, {
                    nombre : sector.nombre,
                    cc     : sector.cc,
                    pmp    : sector.pmp,
                    ur     : sector.ur,
                    sumar  : sector.suma,
                  }).then(function(res){

                  });
                }
              }
            });

            mc.addPlotLineY({
              value    : pmp,
              yAxis    : 4,
              editable : true,
              color    : Config.colors.pmp.background,
              dashStyle : "Dash",
              label    : {
                  text          : "PMP",
                  textAlign     : "right",
                  useHTML       : true,
                  verticalAlign : "middle",
                  align         : "right",
                  x: -20,
                  style         : {
                    color: Config.colors.pmp.background,
                  }
              },
              events: {
                onStop: function(val){
                  console.log("pmp change to " + val);
                  var l = sector.datos[0].length - 1;
                  if(sector.sumar){
                    sector.pmp = val / l;
                  }else{
                    sector.pmp = val;
                  }
                  sector.pmp = val;
                  $http.put(urls.BASE+"/sensor/"+sector.id, {
                    nombre : sector.nombre,
                    cc     : sector.cc,
                    pmp    : sector.pmp,
                    ur     : sector.ur,
                    sumar  : sector.suma,
                  }).then(function(res){

                  });
                }
              }
            });

            mc.addPlotLineY({
              value    : ur,
              yAxis    : 4,
              editable : true,
              color    : "#ef6c00",
              dashStyle : "Dash",
              label    : {
                  text          : "UR",
                  textAlign     : "right",
                  useHTML       : true,
                  verticalAlign : "middle",
                  align         : "right",
                  x: -20,
                  style         : {
                    color: Config.colors.ur.background,
                  }
              },
              events: {
                onStop: function(val){
                  console.log("UR change to " + val);
                  var l = sector.datos[0].length - 1;
                  if(sector.sumar){
                    sector.ur = val / l;
                  }else{
                    sector.ur = val;
                  }
                  sector.ur = val;
                  $http.put(urls.BASE+"/sensor/"+sector.id, {
                    nombre : sector.nombre,
                    cc     : sector.cc,
                    pmp    : sector.pmp,
                    ur     : sector.ur,
                    sumar  : sector.suma,
                  }).then(function(res){

                  });
                }
              }
            });



            //var diasFaltantes        = _.round((consumosValidos.ultimo - UR) / consumosValidos.promedio, 1);
            var sensoresList         = [];
            var sensoresSelectedList = [];
            var i                    = 0;

            _.each(dataSensor, function(ds, index){
              ds.sort(sortFunction);
              var arr = [cc, pmp, ur];
              arr = arr.sort(function(a, b){return a - b});
              var color = Config.colors.list[i];
              var d = {
                id           : _.random(10, 100000),
                color        : color,
                type         : 'line',
                name         : index+"cm",
                lineWidth    : 1,
                data         : ds,
                yAxis        : 4,
                softMax      : arr[arr.length-1] + 5,
                softMin      : arr[0] - 5,
                tag          : "sensor",
                visible      : false,
                visibleAxis  : true,
                legend       : false,
                oppositeAxis : false
              };
              mc.agregarSerie(d);
              var s = {
                name  : index+"<span> cm</span>",
                index : index,
                data  : ds,
                sum   : true,
                color : color
              };
              sensoresList.push(s);
              sensoresSelectedList.push(s);
              i++;
            });

            mc.agregarSerie({
              id        : "ss", //_.random(10, 100000),
              name      : sector.sumar ? "suma" : "promedio",
              type      : "line",
              lineWidth : 1,
              data      : dataSumSensores,
              yAxis     : 4,
              color     : "black",
              tag       : "sumasensor",
              visibleAxis: true,
              oppositeAxis: false
            });

            vm.sectoresSensor.push({
              mc               : mc,
              edit             : false,
              config           : mc.getConfig(),
              sector           : sector,
              sensores         : sensoresList,
              sensoresSelected : sensoresSelectedList
            });
            mcSensores.push(mc);
          });
          vm.loading.getSensores = false;
        });



      }








      /**
       * init
       */
      var init = function(){

        // asigna color segun estanque.actual_por (estanque actual porcentaje)
        _.each(equipos, function(equipo){
          _.each(equipo.sector_riego, function(sector){
            sector.className = vm.getSemaforoByNum(sector.estanque.actual_por);
            sector.kc.teorico_div = _.round(sector.kc.teorico / 100, 3);
            sector.kc.kc_programa_div = _.round(sector.kc.kc_programa / 100, 3);
            if( !_.isArray(sector.resumen.calidades) &&
                _.isObject(sector.resumen.calidades)){
              sector.resumen.calidades = [
                sector.resumen.calidades
              ];
            }
            if(sector.ultimo_riego && sector.ultimo_riego.horas_reales) {
              sector.ultimo_riego.horas_reales_formated = moment(new Date(1970, 0, 1, 0, 0, 0)).add(sector.ultimo_riego.horas_reales, "hours").seconds(0).format("H:mm");
            }
            if(sector.estanque && sector.estanque.riego_normal_hh) {
              sector.estanque.riego_normal_hh_formated = moment(new Date(1970, 0, 1, 0, 0, 0)).add(sector.estanque.riego_normal_hh, "hours").seconds(0).format("H:mm");
            }
          });
        });

        initTemporadas();
        initGD();
        if(!vm.isMobile){
          initSensores();
        }

      }






      vm.changeSensoresSelected = function(sectorSensor){
        var mc            = sectorSensor.mc;
        var dataSumSensor = [];
        _.each(sectorSensor.sensoresSelected, function(ss){
          _.each(ss.data, function(d, i){
            if(dataSumSensor[i] == undefined){
              dataSumSensor.push([
                d[0],
                0
              ]);
            }
            dataSumSensor[i][1] += d[1];
          });
        });
        if(!sectorSensor.sector.sumar){
          _.each(dataSumSensor, function(d){
            d[1] = _.round(d[1] /sectorSensor.sensoresSelected.length, 1);
          });
        }
        mc.setSerie("ss", dataSumSensor, true);
        //TODO recalcular consumos
        var validObj = SensorFac.getValidDays({
          data: dataSumSensor,
          tolerancia : tolerancia_validez_dia, //tolerancia de % de validez de un dia
          // cc: CC,
          // ur: UR
        });
        var valid           = validObj.days;
        //var consumos        = SensorFac.getConsumos(dataSumSensor);
        var consumosValidos = SensorFac.getConsumos(dataSumSensor, valid);
        //n
        //mc.setSerie("dev_consumos", consumos.data);
        mc.setSerie("dev_consumos_validos", consumosValidos.data, false);
        //mc.setSerie("dev_valid_day",valid, false);
        //mc.setSerie("dev_valid_all",validObj.all, false);
        mc.setSerie("dev_pendientes",validObj.pendientes,true);
        //sectorSensor.diasFaltantes = _.round((consumosValidos.ultimo - UR) / consumosValidos.promedio, 1);

      }


      vm.editSensor = function(sectorSensor){
        sectorSensor.edit = !sectorSensor.edit;
        sectorSensor.mc.sensorEditable(sectorSensor.edit);
      }

      vm.toggleSum = function(){
        var t = 0;
        _.each(mcSensores, function(mcs){
          $timeout(function(){
            mcs.toggleSeriesByTag("sensor", vm.visibleSensores, false);
            mcs.toggleSeriesByTag("sumasensor", !vm.visibleSensores, true);
          }, t);
          t += 50;
        });
      };

      /*
      vm.toggleSeriesDebug = function(){
        var t = 0;
        _.each(mcSensores, function(mcs){
          $timeout(function(){
            mcs.toggleSeriesByTag("debug", vm.visibleSeriesDebug,true);
          }, t);
          t += 500;
        });
      };

      vm.showSum = function(){
          vm.showedTemp    = false;
          mchart.toggleSeriesByTag("sumaClima", true, false);
          mchart.toggleSeriesByTag("temp", false,false);
          //mchart.redraw();
      };

      vm.showTemp = function(){
          vm.showedTemp    = true;
          mchart.toggleSeriesByTag("sumaClima",false, false);
          mchart.toggleSeriesByTag("temp",true,false);
      };
      */

      vm.agregarEtDialog = function(type, ev){
        $mdDialog.show({
          controller:["$scope", "$mdDialog", function($scope, $mdDialog){
            $scope.fecha = new Date();
            $scope.newEt = 0;
            $scope.type = type;
            $scope.hide = function(){
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.answer = function() {
              VinedoFac[type]({
                vinedo_id : vinedo.data.id,
                fecha     : moment($scope.fecha).format("DD-MM-YYYY"),
                cantidad  :$scope.newEt
              }, function(){
                $mdDialog.hide();
                vm.refreshDataClima(type, moment($scope.fecha).unix(), $scope.newEt)
                $mdToast.show($mdToast.simple()
                  .position('top right')
                  .textContent('dato de '+type+" guardado"));
              });
            };
          }], // end controller

          templateUrl: 'components/vinedo/resumen/et.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: false //$scope.customFullscreen // Only for -xs, -sm breakpoints.
        })
          .then(function(answer) {

          }, function() {

          });
      };





    vm.estimar = function(tipo, sectorParam, type){

      var cantidad                 = 0;
      var sector                   = null;
      var params                   = {};
      sector                       = sectorParam;
      sector.estimacion.horas      = sector.estanque.riego_normal_hh;
      sector.estimacion.mm         = sector.estanque.riego_normal_mm;
      //sector.estimacion.reposicion = parseFloat(sector.kc.teorico); //innecesario para cuando se llama desde estimarWindow
      sector.estimacion.reposicion = sector.estimacion.reposicionEditable;
      sector.loading               = true;

      if(type == "hh"){
        var mm = sectorParam.estanque.riego_normal_hh * sectorParam.precipitacion_sistema_mm;
        sectorParam.estanque.riego_normal_mm = _.round(mm, 2);
      }
      if(type == "mm"){
        var hh = sectorParam.estanque.riego_normal_mm / sectorParam.precipitacion_sistema_mm;
        sectorParam.estanque.riego_normal_hh = _.round(hh, 2);
      }
      if(type == "dias"){
        params.frecuencia_riego = parseInt(sector.proximo.frecuencia);
      }

      params.milimetros_riego           = sector.estanque.riego_normal_mm;
      params.tiempo_riego               = sector.estanque.riego_normal_hh;
      params.tipo_calculo_proximo_riego = sector.estimacion.tipo;
      params.sector_riego_id            = sector.id;

      switch (tipo) { //-¿esto es necesario?
        case "sector":
          params.sector_riego_id = sector.id;
          break;
        case "equipo":
          params.equipo_id       = sector.equipo_id;
          break;
        case "vinedo":
          //opcion solo para vista de vinedo
          params.vinedo_id       = $stateParams.id;
          break;
        case "calidad":
          params.calidad_id      = calidad.id;
          break;
        default:
          console.error("tipo sector no encontrado");
      }


      if(sector.estimacion.reposicion !== undefined){
        params.kr = parseFloat(sector.estimacion.reposicion) / 100;
      }else{
        params.kr = 1;
      }


      $http.post(urls.BASE+"/sector-riego/variables", params)
      .then(function(response){


        angular.forEach(response.data.data, function(cuartelId) {
          angular.forEach(equipos, function(equipo) {
            angular.forEach(equipo.sector_riego, function(cuartel) {
              if (cuartel.id == cuartelId) {
                vm.reloadResumen(cuartel.id);
                cuartel.loading = true;
              }
            });
          });
        });
      });

/*
      $http.post(urls.BASE+"/sector-riego/variables", paramsKr)
      .then(function(response) {
        $http.post(urls.BASE+"/sector-riego/variables", paramsMM)
            .then(function(response) {
              $http.post(urls.BASE+"/sector-riego/variables", paramsHH)
                  .then(function(response) {

                    angular.forEach(response.data.data, function(cuartelId) {
                      angular.forEach(vm.equipos, function(equipo) {
                        angular.forEach(equipo.sector_riego, function(cuartel) {
                          if (cuartel.id == cuartelId) {
                            cuartel.loading = true;
                            if (["equipo", "calidad"].indexOf(tipo) > -1) {
                              cuartel.estimacion.reposicion = sectorParam.estimacion.reposicionEditable;
                              cuartel.kr = cuartel.estimacion.reposicion / 100;
                              cuartel.riego_normal_hh = sectorParam.estimacion.horas;
                             cuartel.riego_normal_mm = sectorParam.estimacion.mm; //¿?¿?¿?
                            }
                          }
                        });
                      });
                    });

                    $timeout(function(){
                      regenerarSectoresServer(response.data.data);
                    });

                  }, function(response) {
                    //ERROR Horas-dias
                    //$log.error("guardar HH");
                  });
            }, function(response) {
          //ERROR Horas-dias
          //$log.error("guardar MM");
        });

      }, function(response) {
        //ERROR KR
        //$log.error("guardar KR");
      });
      */

    };






      vm.showEstimacion = function(sector_id, ev){
        var s = vm.getSectorById(sector_id);
        var sector = s.sector;
        var equipo = s.equipo;
        $mdDialog.show({
          controller:["$scope", "$mdDialog", "Config", function($scope, $mdDialog, Config){

            $scope.sector           = sector;
            $scope.equipo           = equipo;
            $scope.sector.equipo_id = equipo.id;

            //variables faltantes
            $scope.sector.kr = sector.kc.teorico;
            $scope.sector.promedio_et = 7; //FALTA
            //$scope.sector.precipitacion_sistema = 14;

            $scope.sector.precipitacion_sistema_mm = (sector.precipitacion_sistema);

            $scope.sector.estimacion = {
              //reposicion : $filter('number')( $scope.cuartelWindow.kr * 100 , 0 ),
              reposicion         : _.round($scope.sector.kc.teorico),
              reposicionEditable : _.round($scope.sector.kc.teorico),
              dias               : $scope.sector.proximo.frecuencia,
              horas              : $scope.sector.estanque.riego_normal_hh,
              mm                 : $scope.sector.estanque.riego_normal_mm,
              tipo               : $scope.sector.proximo.tipo_calculo
            };



            $scope.hide = function(){
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };

            $scope.estimarEquipo = function(){
              //hacer estimacion
              $(ev.currentTarget).find(".loading").removeClass("hide");

              var v = "";
              if(sector.estimacion.tipo === 3){
                v = "dias";
              }
              if(sector.estimacion.tipo === 2){
                sector.estanque.riego_normal_hh = sector.estimacion.horas;
                v = "hh";
              }
              if(sector.estimacion.tipo === 1) {
                sector.estanque.riego_normal_mm = sector.estimacion.mm;
                v = "mm";
              }
              vm.estimar("equipo", sector, v);
              $mdDialog.hide();
            }


            $scope.estimar = function(){
              //hacer estimacion
              $(ev.currentTarget).find(".loading").removeClass("hide");

              var v = "";
              if(sector.estimacion.tipo === 3){
                v = "dias";
              }
              if(sector.estimacion.tipo === 2){
                sector.estanque.riego_normal_hh = sector.estimacion.horas;
                v = "hh";
              }
              if(sector.estimacion.tipo === 1) {
                sector.estanque.riego_normal_mm = sector.estimacion.mm;
                v = "mm";
              }
              vm.estimar("sector", sector, v);
              $mdDialog.hide();
            }

          }], // end controller

          templateUrl         : 'components/vinedo/resumen/estimacion.tmpl.html',
          parent              : angular.element(document.body),
          targetEvent         : ev,
          clickOutsideToClose : true,
          fullscreen          : false //$scope.customFullscreen // Only for -xs, -sm breakpoints.
        })
          .then(function(tipo, sector) {

          }, function() {

          });
      };





      vm.agregarCalicataDialog = function(sector_id, ev){
        var s = vm.getSectorById(sector_id);
        var sector = s.sector;
        var equipo = s.equipo;
        $mdDialog.show({
          controller:["$scope", "$mdDialog", function($scope, $mdDialog){
            $scope.fecha = new Date();
            $scope.sector = sector;
            step = 20;
            min = 20;
            max= 80;
            $scope.alturas = [];

            for (var i = min; i <= max; i+=step) {
              $scope.alturas.push({
                name: i+" cm",
                num: i,
                value: ''
              });
            }

            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };

            $scope.agregarAltura =function(altura, value){
              $alturas.push({
                name: altura+" cm",
                num: altura,
                value: value || null
              });
            }

            $scope.answer = function(answer) {
              //TODO save
            };
          }],
          templateUrl         : 'components/vinedo/resumen/calicata.tmpl.html',
          parent              : angular.element(document.body),
          targetEvent         : ev,
          clickOutsideToClose : true,
          fullscreen          : false //$scope.customFullscreen // Only for -xs, -sm breakpoints.
        })
          .then(function(answer) {

          }, function() {

          });
      };



    function floatToDuration(num){
      var h = _.round(num, 0);
      var m = _.round((num - h)*60, 0);
      var mHora = moment.duration(h, "hours");
      mHora.add(m, "minutes");
      return mHora;
    }



    var guardarReal = function(dia, cuartel, callback){
      var usaMM           = Config.vinedo.usaMM || false ;
      var conCaudalimetro = Config.vinedo.conCaudalimetro || false;
          if(usaMM){
            dia.horas_reales = dia.riego_real / cuartel.precipitacion_sistema;
            dia.riego_real   = dia.riego_real;
          }else{
            dia.riego_real   = dia.horas_reales * cuartel.precipitacion_sistema;
            dia.horas_reales = dia.horas_reales;
          }

          if(conCaudalimetro){
            dia.volumen_real = parseFloat(vm.MIVol);//obtiene vol de multiInput
            dia.volumen      = parseFloat(vm.MIVol);
            if (!usaMM) {
                delete dia.riego_real; // asi el riego real se recalcula en backend
            }
          }else{
            //si no tiene caudalimetro, se recalcula el volumen
            dia.volumen_real = dia.riego_real * cuartel.ha * 10;
            dia.volumen      = dia.riego_real * cuartel.ha * 10;
          }

          var data = {
            sector_riego_id : cuartel.id,
            //mm_reales       : dia.riego_real ,
            horas_reales    : dia.horas_reales,
            volumen         : dia.volumen_real,
            fecha           : moment.unix(dia.unix).format("YYYY-MM-DD")
          };

          if (dia.riego_real !== undefined) {
            dia.riego_real = _.round(dia.riego_real, 2);
            data.mm_reales = dia.riego_real;
          }


          CuartelRes.riegoDia(data, function (res) {
            /*var d = ppfac.calcularSemana(cuartel, dia);
            var data2 = {
              sector_riego_id : cuartel.id,
              volumen_real    : d.volumen,
              horas_reales    : d.horas,
              fecha           : moment.unix(dia.unix).format("YYYY-MM-DD")
            };
            CuartelRes.riegoSemana(data2, function (res2) {
              if(angular.isDefined(callback)){
                callback(res2);
              }
            });
            */

              if(angular.isDefined(callback)){
                callback(res);
              }

          });
        }// END guardarReal









      vm.agregarRiegoDialog = function(sector_id, ev){
        var s      = vm.getSectorById(sector_id);
        var sector = s.sector;
        var equipo = s.equipo;
        $mdDialog.show({
          controllerAs:"vm",
          controller:["$scope", "$mdDialog", function($scope, $mdDialog){

            var vmDialog = this;

            vmDialog.fecha           = new Date();
            vmDialog.mm              = 0;
            vmDialog.horas           = 0;
            vmDialog.minutos         = 0;
            vmDialog.sector          = sector;
            vmDialog.usaMM           = Config.vinedo.usaMM || false ;
            vmDialog.conCaudalimetro = Config.vinedo.conCaudalimetro || false;
            vmDialog.volumen         = 0;

            vmDialog.hide = function() {
              $mdDialog.hide();
            };

            vmDialog.cancel = function() {
              $mdDialog.cancel();
            };

            vmDialog.answer = function(answer) {

              var mHora = floatToDuration(parseFloat(vmDialog.horas));
              mHora.add(parseFloat(vm.MIMin), "minutes");
              var time = mHora.asHours();

              var dia = {
                unix         : moment(vmDialog.fecha).unix(),
                horas_reales : time,
                volumen_real : vmDialog.volumen,
                volumen      : vmDialog.volumen,
                riego_real   : vmDialog.mm
              }

              guardarReal(dia, sector, function() {
                //regenerarSectorServer(cuartelDia.sector);
                vm.reloadResumen(sector.id);
                $mdDialog.hide();
                $mdToast.show($mdToast.simple()
                  .position('top right')
                  .textContent('Riego guardado'));
              });



            };
          }],
          templateUrl         : 'components/vinedo/resumen/nuevo_riego.tmpl.html',
          parent              : angular.element(document.body),
          targetEvent         : ev,
          clickOutsideToClose : true,
          fullscreen          : false //$scope.customFullscreen // Only for -xs, -sm breakpoints.
        })
          .then(function(answer) {

          }, function() {

          });
      };







      vm.agregarScholanderDialog = function(sector_scholander_id, sector_id, unix_ultimo_scholander, ev){
        var numObj = $(ev.target.parentNode).find(".num");
        var s      = vm.getSectorById(sector_id);
        var sector = s.sector;

        $mdDialog.show({
          controller : ["$scope", "$mdDialog", function($scope, $mdDialog){
            $scope.fecha         = new Date();
            $scope.newScholander = 0;
            $scope.sector        = sector;

            $scope.hide = function() {
              $mdDialog.hide();
            };

            $scope.cancel = function() {
              $mdDialog.cancel();
            };

            $scope.answer = function(answer) {
              //$mdDialog.hide(answer);
              console.log(unix_ultimo_scholander); // fecha ultimo dato guardado
              console.log($scope.fecha); // fecha dato nuevo
              //TODO si la fecha del nuevo es mas reciente que el guardado, y es pasado, mostrar nuevo dato
              var mf = moment($scope.fecha);
              var m  = moment(unix_ultimo_scholander);
              if(m.isSame(mf) || m.isBefore(mf) || unix_ultimo_scholander == null){
                numObj.html($scope.newScholander+" ");
              }
              EquipoRes.schol({
                fecha     : moment($scope.fecha).format("YYYY-MM-DD"),
                sector_id : sector_scholander_id,
                cantidad  : $scope.newScholander,
              }, function(){
                //done
                $mdDialog.hide();
                $mdToast.show($mdToast.simple()
                  .position('top right')
                  .textContent('Dato de Scholander guardado'));
                vm.reloadResumen(sector.id);
              });
            };

          }],
          templateUrl         : 'components/vinedo/resumen/scholander.tmpl.html',
          parent              : angular.element(document.body),
          targetEvent         : ev,
          clickOutsideToClose : true,
          fullscreen          : false //$scope.customFullscreen // Only for -xs, -sm breakpoints.
        })
          .then(function(answer) {

          }, function() {

          });
      };





      /**
       * Items es el contenido de la tabla resumen
       */

      vm.items = {
        header:[

          {
            title: "Estimación",
            className:"no-print",
            subitems:[
              {
                title: "",
                col: "col-3",
                itemClassName: "item-with-button",
                buttons:[
                  {
                    ink: true,
                    className:"button-estimacion",
                    text:"<md-icon class='material-icons'>&#xE5D4;</md-icon>",
                    onClick: "vr.showEstimacion",
                    permission: "editar-vinedo-"
                  }
                ]
              },


            ]
          },







          /*
          {
            title: "Frecuencia",
            subitems:[
              // {
              //   title: "Frec dias",
              //   col: "col-3",
              //   v:"riego.frecuencia",
              // },
              // {
              //   title: "Hrs",
              //   col: "col-2",
              //   v:"riego.tiempo",
              // },
              // {
              //   title: "Nº",
              //   col: "col-2",
              //   v: "riego.cantidad"
              // },
              {
                title: "",
                col: "col-3",
                suffix:" dias",
                v: "proximo.frecuencia",
              },
            ]
          },
          */


          /*{
            title: "Hace",
            subitems:[
              {
                title: "",
                col: "col-2",
                v:"ultimo_riego.dias_atras",
                suffix:"dias"
              },
            ]
          },

          */


          /*
          {
            title: "Faltan",
            subitems:[
              {
                title: "",
                col: "col-3",
                v:"proximo.dias",
                suffix:"dias"
              },
            ]
          },
*/


          {
            title: "Último Riego",
            subitems:[
              // {
              //   title: "Fecha",
              //   col: "col-3",
              //   v: "ultimo_riego.unix"
              // },
              //
              {
                title: "hrs",
                col: "col-3",
                 v:"ultimo_riego.horas_reales_formated",
                suffix:"hrs"
              },
              {
                title: "mm",
                col: "col-3",
                 v:"ultimo_riego.mm_reales",
                suffix:"mm"
              },
              {
                title: "% rep",
                col: "col-3",
                v:"ultimo_riego.reposicion",
                suffix:"%"
              },
              {
                title: "hace",
                col: "col-2",
                v:"ultimo_riego.dias_atras",
                suffix:"dias"
              },
            ]
          },






          {
            title: "Estimación Riego",
            subitems:[
              // {
              //   title: "Fecha",
              //   col: "col-3",
              //   v: "proximo.unix"
              // },
              // {
              //   title: "mm",
              //   col: "col-2",
              //   //v: ""
              // },DemoViña
              // {
              //   title: "kc teorico",
              //   col: "col-3",
              //   //v: ""
              // },
              {
                title: "hrs",
                col: "col-3",
                v: "estanque.riego_normal_hh_formated",
                suffix:"hrs"
              },
              {
                title: "mm",
                col: "col-3",
                v: "estanque.riego_normal_mm",
                suffix:"mm"
              },
              {
                title: "% rep prog",
                col: "col-3",
                v: "kc.kc_programa",
                suffix: " %"
              },
              {
                title: "faltan",
                col: "col-3",
                v:"proximo.dias",
                suffix:"dias"
              },
            ]
          },



              {
                title: "Hoy",
                subitems:[
              {
                title: "Et acum",
                col: "col-3",
                v:"kc.eta",
                suffix:"mm"
              },
              {
                title: "% rep",
                col: "col-3",
                v:"kc.hoy",
                suffix:"%"
              },
                ]
              },







          {
            title: "Schol",
            visible: (Config.vinedo.conScholander || false) ,
            subitems:[

              {
                title: "limite",
                col: "col-2",
                v: "kc.limite_scholander",
                suffix:"bar",
              },
              {
                title: "última",
                col: "col-3",
                v: "scholander.cantidad",
                suffix:"bar",
                buttons:[
                  {
                    className:"add-scholander add-button",
                    tag: "scholander",
                    text:"+",
                    onClick: "vr.agregarScholanderDialog",
                    permission: "editar-vinedo-scholander"
                  }
                ]
              },
              {
                title: "fecha ",
                col: "col-2",
                v: "scholander.fecha",
                type:"date_string"
              }
            ]
          },

          {
            title: "Riego",
            className: "no-print",
            subitems:[
              {
                title: "agregar",
                col: "col-2",
                itemClassName: "item-with-button",
                //v: "",
                buttons:[
                  {
                    className:"add-riego add-button",
                    text:"+",
                    onClick: "vr.agregarRiegoDialog",
                    permission: "editar-vinedo-riego"
                  }
                ]
              },

            ]
          },


          // {
          //   title: "Temporada",
          //   subitems:[
          //     {
          //       title: "m<sup>3</sup> /ha",
          //       col: "col-3",
          //       v: "temporada.volumenHA"
          //     },
          //   ]
          // },


          /*
          {
            title: "Calicata",
            subitems:[
              {
                title: "",
                col: "col-2",
                itemClassName: "item-with-button",
                //v: "",
                buttons:[
                  {
                    className:"add-calicata add-button",
                    text:"+",
                    onClick: "vr.agregarCalicataDialog",
                  }
                ]
              },
            ]
          },
          */



/*
          {
            title: "kc",
            subitems:[
              // {
              //   title: "Frec dias",
              //   col: "col-3",
              //   v:"riego.frecuencia",
              // },
              // {
              //   title: "Hrs",
              //   col: "col-2",
              //   v:"riego.tiempo",
              // },
              // {
              //   title: "Nº",
              //   col: "col-2",
              //   v: "riego.cantidad"
              // },
              // {
              //   title: "15 dias",
              //   col: "col-3",
              //   v: "riego.kc",
              // },
            ]
          },
*/





        ],
        equipos:equipos
      };



      vm.getSectorById = function(id){
        var s = null;
        var e = null;
        _.each(equipos, function(eq){
          _.each(eq.sector_riego, function(sec){
            if(sec.id == id){
              s = sec;
              e = eq;
            }
          });
        });
        return {
          sector: s,
          equipo: e
        };
      }



      vm.showDialogSector = function(ev, sector_id) {
        cuartelDialog.showDialog(ev, sector_id);
      }



      var generateTable = function(items){

        var headerTmpl =
          '<div class="header">'+
            '<div class="corner">'+
              '<span>'+
              'Sectores'+
              '</span>'+
            '</div>'+ // .corner
            '<%  _.each(items.header, function(item){ %>'+
              '<% if(item.visible !== false){ %>'+
                  '<div class="header-table <%= item.className %>">'+
                    '<div class="header-title"> <%= item.title %> </div>'+
                    '<div class="header-subtitle-container">'+
                      '<%  _.each(item.subitems , function(subitem){ %>'+
                        '<div class="header-subtitle <%= subitem.col %>" > <%= subitem.title %> </div>'+
                      '<% })  %>'+
                    '</div>'+
                  '</div>'+ // .header-table
              '<% }  %>'+
            '<% })  %>'+
          '</div>';

        var headerComp = _.template(headerTmpl, { 'imports': { '_': _ } });
        var header = headerComp({ 'items': items});


        var sidebarTmpl =

          '<div class="sidebar">'+
            '<%  _.each(items.equipos, function(equipo){ %>'+
            '<%  if((equipoSelected == null || equipo.id == equipoSelected.id) && (casetaSelected == null || casetaSelected.id == equipo.caseta_id)){ %>'+
              '<div class="nav-group-item">'+
                '<div class="title-group-item truncate"><%= equipo.nombre %></div>'+
                '<%  _.each(equipo.sector_riego, function(sector){ %>'+
                    '<div class="nav-item" md-ink-ripple" '+
                                          'ng-click="vr.showDialogSector($event, <%= sector.id%>)">'+
                      //'<div class="light <%= sector.color %>"></div>'+
                      '<div class="light <%= sector.className %>"></div>'+
                      '<div class="title-item truncate" > <%= sector.nombre %> </div>'+
                        '<% if(sector.resumen.calidades.length > 0) { %>'+
                          '<div class="subtitle-item truncate">'+

                            '<%  _.each(sector.resumen.calidades, function(c){ %>'+
                              '<%= c.variedad_nombre %> -'+
                              '<%= c.calidad_nombre %>'+
                            '<% })  %>'+

                          '</div>'+ //.subtitle-item
                        '<% }  %>'+
                    '</div>'+ //.nav-item
                '<% })  %>'+
              '</div>'+ //.nav-group-item
            '<% }  %>'+
            '<% })  %>'+
          '</div>';

        var sidebarComp = _.template(sidebarTmpl, { 'imports': { '_': _ }});
        var sidebar = sidebarComp({ 'items': items , 'casetaSelected':vm.casetaSelected, 'equipoSelected':vm.equipoSelected});


        var bodyTmpl =

          '<div class="body">'+
            '<%  _.each(items.equipos, function(equipo){ %>'+
            '<%  if((equipoSelected == null || equipo.id == equipoSelected.id) && (casetaSelected == null || casetaSelected.id == equipo.caseta_id)){ %>'+
                '<div class="group">'+
                  '<div class="row-sticky">'+
                    '<div class="item"> -- '+
                      //'<%= equipo.nombre %>'+
                    '</div>'+
                  '</div> <!-- .row-sticky -->'+
                  '<%  _.each(equipo.sector_riego, function(sector){ %>'+
                    '<div class="row" data-id="<%= sector.id %>">'+
                    sectorTable() +
                    '</div> <!-- .row -->'+
                  '<% })  %>'+
                '</div> <!-- .group -->'+
            '<% }  %>'+
            '<% })  %>'+
          '</div> <!-- .body -->';

        var bodyComp = _.template(bodyTmpl, { 'imports': { '_': _, 'get': vm.get, 'vp':verifyPermission } });
        var body = bodyComp({ 'items': items , 'casetaSelected':vm.casetaSelected, 'equipoSelected':vm.equipoSelected});


        var open     = '<div class="irritable-flex"> <div class="container">';
        var close    = '<div class="footer"></div></div></div>';
        var html     = open +  header + sidebar + body + close
        var compiled = $compile(html)($scope)
        $("#irritable").html(compiled);

      };

      var buttons = function(){
          return '<% _.each(subitem.buttons, function(button){ %>'+

            '<% if(vp(button.permission)) { %>'+
              '<% if(button.tag == "scholander") { %>'+
              //boton scholander
                '<% if(sector.sector_scholander_id !== null && sector.sector_scholander_id !== undefined) { %>'+
                  '<% if(sector.scholander !== null) { %>'+
                    '<button <%= button.ink ? "md-ink-ripple":""%> class="<%= button.className %>" ng-click="<%= button.onClick %>(<%= sector.sector_scholander_id %>, <%= sector.id %> , <%= sector.scholander.unix %>, $event)">'+
                      '<%= button.text %>'+
                    '</button>'+
                  '<% }else{  %>'+
                    '<button <%= button.ink ? "md-ink-ripple":""%> class="<%= button.className %>" ng-click="<%= button.onClick %>(<%= sector.sector_scholander_id %>, <%= sector.id %> , null, $event)">'+
                      '<%= button.text %>'+
                    '</button>'+
                  '<% }  %>'+

                '<% }else{  %>'+
                    '<button <%= button.ink ? "md-ink-ripple":""%> class="<%= button.className %>  no-print" disabled >'+
                      '<%= button.text %>'+
                    '</button>'+
                '<% }  %>'+



              '<% }else{  %>'+
              //boton normal
                    '<button <%= button.ink ? "md-ink-ripple":""%> class="<%= button.className %>" ng-click="<%= button.onClick %>(<%= sector.id%>, $event)">'+
                      '<%= button.text %>'+
                      '<md-progress-circular class="hide loading" md-diameter="30px" md-mode="indeterminate"></md-progress-circular>'+
                    '</button>'+
              '<% }  %>'+
            '<% }  %>'+

          '<% })  %>';
      }


      vm.regenerateSector = function(idSector){
        var s        = vm.getSectorById(idSector);
        var sector   = s.sector;
        sector.kc.teorico_div = _.round(sector.kc.teorico / 100, 3);
        sector.kc.kc_programa_div = _.round(sector.kc.kc_programa / 100, 3);
        //sector.estanque.actual_mm = _.random(10, 100);// TEST
        var str      = sectorTable();
        var bodyComp = _.template(str, { 'imports': { '_': _, 'get': vm.get, 'vp':verifyPermission  } });
        var body     = bodyComp({ 'sector':sector, 'items': vm.items});
        var compiled = $compile(body)($scope)
        $(".row[data-id='"+idSector+"']").html(compiled);
      }



      var verifyPermission = function(permission){
            var hasPermission = false;
            if (permission) {
              if (angular.isDefined(Config.user[permission])) {
                  hasPermission = Config.user[permission];
              }
            }else{
              hasPermission = true;
            }
        return hasPermission;
      }

      vm.verifyPermission = verifyPermission;




      var sectorTable = function(){
        return '<%  _.each(items.header, function(item){ %>'+
                  '<% if(item.visible !== false){ %>'+
                          '<div class="h-item  <%= item.className %>"" >'+
                            '<%  _.each(item.subitems, function(subitem){ %>'+
                                '<div class="item <%= subitem.col %> <%= subitem.itemClassName %>" >'+
                                  '<span class="num"><%= get(sector, subitem.v, subitem.type) %> </span>'+
                                  '<span class="suffix"><%= subitem.suffix %></span>'+
                                  buttons() +
                                '</div>'+
                            '<% })  %>'+
                          '</div>'+
                      '<% }  %>'+
                  '<% })  %>';
      }





      vm.showChartSensores = function(){
        vm.visible = true;
        if(vm.sectoresSensor.length > 0){
          $timeout(function(){
            window.dispatchEvent(new Event('resize'))
          }, 100);
        }else{
          initSensores();
        }
      }

      vm.hideChartSensores = function(){
        vm.visible = false;
      }


      vm.filterTable = function(){
        if(vm.casetaSelected !== null && vm.equipoSelected !== null){
          if(vm.casetaSelected.id !== vm.equipoSelected.caseta_id){
            vm.equipoSelected = null;
          }
        }
        vm.regenerateTable();
      }


      vm.regenerateTable = function(){
        generateTable(vm.items);
      }

      vm.reloadResumen = function(sector_id){
        var v = VinedoRes.getResumen({
          vinedo_id : vinedo.data.id
        }).$promise;
        v.then(function(res){
          equipos = res.data.vinedo.equipos;
          casetas = res.data.vinedo.casetas;
          if(sector_id){
            vm.regenerateSector(sector_id);
          }else{
            vm.regenerateTable()
          }
        })
        return v;
      }

    vm.print = function(){
      window.print();
    }





      init();
      generateTable(vm.items);



  }]);

})();
